import signIn from './Pages/signIn.json';
import signUp from './Pages/signUp.json';

const main = { type: 'RouteManager', pages: [signIn, signUp], defaultUri: '/login' };

export default main;
